import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { i18n } from 'app/i18n';
import { selectIsAuthenticated } from 'app/pages/auth/redux/auth-selectors';
import logoHorizontal from 'app/resources/logo-desktop.svg';
import logoVertical from 'app/resources/logo-mobile.svg';
import { useLargeTabletMediaQuery } from 'app/utils/breakpoints-utils';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { logoutActionCreator } from 'app/pages/logout/redux/action-creators/logout-action-creator';
import { NavigationService } from 'app/services/navigation-service';

import { StyledHeader, StyledHeaderContainer, StyledLogo, StyledLogoutButton } from './header.styled';

export const Header: FunctionComponent = () => {
    // TODO: We should show logout button if user is in choose accounts stage also.
    const showLogoutButton = useSelector(selectIsAuthenticated);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleLogout = (): void => {
        navigate(NavigationService.LOGOUT);
        dispatch(logoutActionCreator());
    };

    const isOnLargeTablet = useLargeTabletMediaQuery();

    const logo = isOnLargeTablet ? logoHorizontal : logoVertical;

    return (
        <StyledHeader>
            <StyledHeaderContainer>
                <StyledLogo src={logo} alt={i18n.image.logo} />
                {showLogoutButton && (
                    <StyledLogoutButton onClick={handleLogout}>{i18n.components.header.logout}</StyledLogoutButton>
                )}
            </StyledHeaderContainer>
        </StyledHeader>
    );
};
